exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buttonItem-linkButton-2eC {\n    text-decoration: underline;\n}\n", ""]);

// Exports
exports.locals = {
	"linkButton": "buttonItem-linkButton-2eC"
};